import React from "react";
import Banner from "../Banner/Banner";
import "./blogs.scss";
import { recentArticlesData } from "./blogData";

const BlogPage = () => {
  return (
    <>
      <Banner title={"Blogs"} />
      <div className="section blog">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6 ">
              <h5 className="mb-3">Recent Articles</h5>
              {recentArticlesData.map((recent) => (
                <div className="recent_articles">
                  <div className="img">
                    <img
                      className="article_img"
                      src={recent.img}
                      alt={recent.title}
                    />
                  </div>
                  <div className="text">
                    <h4>{recent.title}</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Beatae, asperiores?
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-9 col-md-9 col-sm-8 col-xs-6">
              <h2 className="mb-5 text-center">NEWS ARTICLES</h2>
              {recentArticlesData.map((recent) => (
                <div className="articles mb-5">
                  <div className="img mb-3">
                    <img
                      className="articles_img"
                      src={recent.img}
                      alt={recent.title}
                    />
                  </div>
                  <div className="text">
                    <h2 >{recent.title}</h2>
                    <h6 className="card-title"><i className="far fa-user fa-1x"></i> Admin <span class="badge bg-success text-white">{recent.badge}</span></h6>
                    <p>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Esse obcaecati, molestias culpa voluptates nobis non quos
                      commodi blanditiis atque id temporibus praesentium rerum
                      dicta magni illum nostrum, exercitationem soluta sapiente.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;
